import React from 'react'

export const CarpoolDashboardIcon: React.FC<{ color?: string; size?: number }> = ({ color = '#E5C265', size = 22 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke={color}
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <title>Map of Carpool Connections</title>
    {/* The main map pin shape */}
    <path d='M21.7 8.3c0 6.6-9.7 12.7-9.7 12.7s-9.7-6.1-9.7-12.7C2.3 4.2 6.7 1 12 1s9.7 3.2 9.7 7.3z'></path>

    {/* A "group of users" icon nested inside the pin */}
    <circle cx='12' cy='9' r='2.5'></circle>
    <path d='M17 14.3c-1.2-1.2-2.8-2-5-2s-3.8.8-5 2'></path>
  </svg>
)
